import {
  BD_DIAGRAM_KINDS,
  type BdDiagramKind,
} from '../components/features/basic-design/BdDiagrams.js';

/** 図だけのページの search param。 @graph-connects none */
export interface BdGraphSearch {
  /** 開く図。無ければ全体図 */
  view?: BdDiagramKind;
}

/** 基本設計のページの search param。 @graph-connects none */
export interface BdDetailSearch {
  /** 最初に開く節（節の定義のキー、または全体・メモ） */
  section?: string;
}

/** 節のキーの形（`screens` や `risk_list`）。 @graph-connects none */
const SECTION_KEY_REGEX = /^[a-z][a-z0-9_]*$/;

/** @graph-connects none */
function isBdDiagramKind(value: unknown): value is BdDiagramKind {
  return BD_DIAGRAM_KINDS.some((kind) => kind === value);
}

/**
 * 図だけのページの search param を読む。
 *
 * 図だけのページは基本設計のページから新しいタブで開かれ、そのページの札から基本設計の節へ戻る。
 * どちらもリンクで渡すので、手で書き換えられた値や古いリンクでもページは開けるよう、
 * 合わない値はエラーにせず落とす。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 図だけのページの search param（開く図）を検証し、合わない値を落とす
 * @graph-connects isBdDiagramKind [calls] 図の種類の判定
 */
export function parseBdGraphSearch(search: Record<string, unknown>): BdGraphSearch {
  return isBdDiagramKind(search.view) ? { view: search.view } : {};
}

/**
 * 基本設計のページの search param を読む。節のキーとして存在するかは定義を読むまで分からないので、
 * ここでは形だけを見る（無い節なら基本設計のページは全体を開く）。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 基本設計のページの search param（最初に開く節）を形で検証し、合わない値を落とす
 * @graph-connects none
 */
export function parseBdDetailSearch(search: Record<string, unknown>): BdDetailSearch {
  const section = search.section;
  return typeof section === 'string' && SECTION_KEY_REGEX.test(section) ? { section } : {};
}
